import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TegelModule } from '@scania/tegel-angular-17';
import { HeaderComponent } from './component/header/header.component';
import { HomeComponent } from './component/home/home.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { RenaveComponent } from './component/menu/renave/renave.component';
import { AcessosUsuariosComponent } from './component/menu/admin/acessos-usuarios/acessos-usuarios.component';
import { SolicitacaoEnvioComponent } from './component/menu/renavam/solicitacao-envio/solicitacao-envio.component';
import { MarcaModeloComponent } from './component/menu/renavam/marca-modelo/marca-modelo.component';
import { NotificacaoComponent } from './component/menu/renavam/notificacao/notificacao.component';
import { CodigosComponent } from './component/menu/renavam/codigos/codigos.component';
import { RetornoPreCadComponent } from './component/menu/renavam/retorno-precad/retorno-precad.component';
import { SpinnerInterceptor } from './service/spinner-interceptor';
import {
  MsalModule,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MsalInterceptor,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication
} from '@azure/msal-browser';

import { environment } from '../environments/environment';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.clientId,
      authority: environment.authUrl,
      redirectUri: environment.redirectUri,
      postLogoutRedirectUri: environment.redirectUri
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();

  protectedResourceMap.set(
    environment.apiUrl,
    [environment.apiScope]
  );

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [environment.apiScope]
    },
    loginFailedRoute: environment.redirectUri
  };
}

@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        HomeComponent,
        RenaveComponent,
        AcessosUsuariosComponent,
        SolicitacaoEnvioComponent,
        MarcaModeloComponent,
        NotificacaoComponent,
        CodigosComponent,
        RetornoPreCadComponent
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [BrowserModule,
        TegelModule,
        AppRoutingModule,
        [SweetAlert2Module.forRoot()],
        [SweetAlert2Module],
        [SweetAlert2Module.forChild({ /* options */}),
        ],
        MsalModule.forRoot(
            MSALInstanceFactory(),
            MSALGuardConfigFactory(),
            MSALInterceptorConfigFactory()
        )], 
    providers: [
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SpinnerInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
